import { ITopic, IEngagementType, IOffering } from "../interfaces/models";
import { apiFetch } from "./APIRepository";

let _topics: {[id: number]: ITopic} = {};
const _engagements: {[id: number]: IEngagementType} = {};

export default class TopicRepository {

    static engagementPointer(engagement: IEngagementType) {
        if (_engagements[engagement.id] === undefined) {
            _engagements[engagement.id] = engagement;
        }
        return _engagements[engagement.id];
    }

    static topicPointer(topic: ITopic) {
        if (_topics[topic.id] === undefined) {
            _topics[topic.id] = topic;
        }
        return _topics[topic.id];
    }

    static topicByID(id: number) {
        if (_topics[id] === undefined) {
            return undefined;
        }
        return _topics[id];
    }

    static topicByName(name: string) {
        for (let id in _topics) {
            if (_topics[id].name == name) {
                return _topics[id];
            }
        }
    }

    static clearPointers() {
        _topics = {};
    }

    static getAllAvailableTopics(): Promise<ITopic[]> {
        return apiFetch<ITopic[]>(`/questions/topics/`)
            .then(topics => topics.map(x => TopicRepository.topicPointer(x)));
    }
    
    static getCoursesForUni(uniName: string): Promise<string[]> {
        return apiFetch<string[]>(`/users/university/${uniName}/`);
    }

    static getOfferingsForCourse(courseCode: string): Promise<IOffering[]> {
        return apiFetch<IOffering[]>(`/users/course/${courseCode}/`);
    }

    static getTopicsForOffering(offeringID: string): Promise<ITopic[]> {
        return apiFetch<ITopic[]>(`/users/offering/topics/${offeringID}/`)
            .then(topics => topics.map(x => TopicRepository.topicPointer(x)));
    }

    static getExisitingTopics(): Promise<ITopic[]> {
        return apiFetch<ITopic[]>(`/questions/topics/all/`);
    }

    static renameTopic(oldTopic: string, newTopic: string) {
        return apiFetch(`/questions/topics/rename/${oldTopic}/${newTopic}/`);
    }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/repositories/TopicRepository.ts